import { Box, Typography } from "@mui/material"
import { styled } from "@mui/system"
import { InfiniteHorizontalScroll } from "components/common/InfiniteHorizontalScroll"
import { UseMoreParams } from "models/convention-api/types"
import ConventionTeamMember from "models/convention-api/v1/ConventionTeamMember"
import React, { useState } from "react"
import TeamMemberCard from "components/team-members/TeamMemberCard"
import { pxToRem } from "utils/helpers"
import TeamMemberCardDialog from "components/team-members/TeamMemberCardDialog"

interface TeamMemberHorizontalScrollProps {
  params: Partial<UseMoreParams>
}

const TeamMemberHorizontalScroll = (props: TeamMemberHorizontalScrollProps) => {
  const { params } = props
  const [readMoreTeamMember, setReadMoreTeamMember] = useState<null | ConventionTeamMember>(null)

  const teamMembers = ConventionTeamMember.useMore({
    limit: 25,
    includeCount: true,
    ...params,
  })

  return (
    <>
      <InfiniteHorizontalScroll.Scroller
        hasMore={!!teamMembers.hasMore}
        loadMore={teamMembers.loadMore}
        isLoading={teamMembers.isLoadingMore}>
        <InfiniteHorizontalScroll.Heading>
          {/*
            If we need to customize heading, we can easily add it later,
            for now it's not important since we don't know when we need it
          */}
          <Heading component="h4">
            Team {teamMembers.count === undefined ? "" : `(${teamMembers.count ?? 0})`}
          </Heading>
        </InfiniteHorizontalScroll.Heading>
        <InfiniteHorizontalScroll.Content>
          <TeamCardsContainer>
            {teamMembers.data?.map((teamMember) => (
              <TeamMemberCard
                key={teamMember.id}
                teamMember={teamMember}
                onReadMore={setReadMoreTeamMember}
              />
            ))}
          </TeamCardsContainer>
        </InfiniteHorizontalScroll.Content>
      </InfiniteHorizontalScroll.Scroller>
      {readMoreTeamMember && (
        <TeamMemberCardDialog
          teamMember={readMoreTeamMember}
          onClose={() => setReadMoreTeamMember(null)}
        />
      )}
    </>
  )
}

export default TeamMemberHorizontalScroll

const Heading = styled(Typography)(({ theme }) => ({
  ...theme.fonts.raleway700,
  fontSize: "18px",
  lineHeight: "1.16",
  color: theme.palette.gray.darkest,
})) as typeof Typography

const TeamCardsContainer = styled(Box)(() => ({
  display: 'flex',
  flexFlow: 'row nowrap',
  gap: pxToRem(20),
  width: '100%',
  paddingBottom: pxToRem(4),
})) as typeof Box

